import * as React from 'react';

import { cn } from '@/lib/cn';

export type DSSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = React.forwardRef<HTMLSelectElement, DSSelectProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={cn(
          'h-11 w-full rounded-md border border-border bg-bg-secondary px-3 text-[17px] text-text-primary transition-all duration-fast ease-out focus:outline-none focus:ring-2 focus:ring-accent',
          className,
        )}
        {...props}
      >
        {children}
      </select>
    );
  },
);

Select.displayName = 'DSSelect';
